// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1cx0B","modalForm":"UpgradeEpcsModal_modalForm__3by6m","modalFooter":"UpgradeEpcsModal_modalFooter__2JO9x"};